import React from 'react';
import { useTranslation } from 'react-i18next';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
import { useDeleteDeviationFlow } from '../../actionHooks/useDeleteDeviationFlow';
export const DeleteButton = ({ deviation, redirectTo })=>{
    const { t } = useTranslation();
    const { enactFlow, biData, supportingComponents } = useDeleteDeviationFlow(deviation, {
        redirectTo,
        supportTierDeletion: true
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        tooltip: t('actionbar.delete')
    }, /*#__PURE__*/ React.createElement(ActionBarEditButton, {
        onClick: enactFlow,
        biData: biData
    }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
        icon: TrashcanIcon
    }))), supportingComponents);
};
DeleteButton.displayName = 'DeleteButton';
export default DeleteButton;
